import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import DataRoomContext from '../../providers/DataRoom/DataRoom.context';
import HelmetWrapper from 'components/HelmetWrapper';
import { Navigate } from 'react-router-dom';
import OnboardingContext from '../../providers/Onboarding/Onboarding.context';
import HotLeads from './componenets/HotLeads';
import ColdLeads from './componenets/ColdLeads';
import ShareableLinksContentContainer from '../../components/ShareableLinksContentContainer';
import TimeframeFilter from '../../components/TimeframeFilter';
import VisitStats from './componenets/VisitStats';
import { useTranslation } from 'react-i18next';
import DashCardHeading from './componenets/DashCardHeading';
import { DATA_ROOM_DASHBOARD_TIMEFRAME } from '../../models/Dashboard';
import {
  TIMEFRAME_FILTER_COPY,
  TimeframeFilterValue,
} from '../../components/TimeframeFilter/data';
import SuggestedActions from './componenets/SuggestedActions';
import dataRoomApi from '../../dataRoomApi';
import ExportAnalyticsButton from '../../components/ExportAnalyticsButton';
import CreateShareableLinkButton from '../../components/DataRoomDocumentsRouter/CreateShareableLinkButton';

import './Dashboard.styles.scss';
import './Dashboard.styles.responsive.scss';

type DashboardProps = {
  className?: string;
};

const Dashboard: React.FC<DashboardProps> = (props) => {
  const { className } = props;

  const {
    isAdmin,
    dataRoom: { _id, name },
    preferredDashboardTimeframe,
    setDataRoom,
  } = useContext(DataRoomContext);
  const { contentCard } = useContext(OnboardingContext);

  const { t } = useTranslation();

  const classes = classNames('dashboard', 'page', className);

  const handleChangeTimeframe = useCallback(
    (timeframe: string) => {
      const preferredDashboardTimeframe = timeframe as TimeframeFilterValue;

      setDataRoom((old) => ({
        ...old,
        currentMember: {
          ...old.currentMember,
          preferredDashboardTimeframe,
        },
      }));
      dataRoomApi.room.updatePreferredValues(_id, {
        preferredDashboardTimeframe,
      });
    },
    [_id, setDataRoom],
  );

  if (!isAdmin) return <Navigate to="../documents" replace />;

  return (
    <div className={classes}>
      <HelmetWrapper title={`Dashboard - ${name}`} />
      <div className="dashboard__name">
        <h2>{name}</h2>
      </div>

      {contentCard}

      <div className="dashboard__content">
        <div className="dashboard__content__wrapper">
          <div className="dashboard__content__wrapper__filters">
            <TimeframeFilter
              selectedTimeframe={preferredDashboardTimeframe}
              onChangeTimeframe={handleChangeTimeframe}
            />

            <ExportAnalyticsButton withExtendedSections />
          </div>

          <div className="dashboard__content__cards">
            <HotLeads className="card" />
            <ColdLeads className="card" />
          </div>
        </div>

        <SuggestedActions className="card" />

        <VisitStats className="card" />

        <div className="dashboard__content__wrapper">
          <DashCardHeading
            heading={t('secureLinks')}
            description={t('trackUserTraffic')}
            showCounter={false}
            showTimeframe={false}
          >
            {t(
              TIMEFRAME_FILTER_COPY[DATA_ROOM_DASHBOARD_TIMEFRAME.THIRTY_DAYS],
            )}
          </DashCardHeading>
          <ShareableLinksContentContainer showVisits onlyActive>
            <div className="dashboard__secure-links-empty">
              <CreateShareableLinkButton />
            </div>
          </ShareableLinksContentContainer>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
